import { useExperience } from '../../../../experiences/context';
import { Provider } from './context';
import { DesktopLayers } from './DesktopLayers';
import { PhoneLayers } from './PhoneLayers';

export function Layers(props) {
  const { isPhone } = useExperience();

  return (
    <Provider {...props}>
      {isPhone ? <PhoneLayers /> : <DesktopLayers />}
    </Provider>
  );
}
